<app-spinner></app-spinner>
<div appMousemoveDetector></div>
<mat-toolbar color="primary">
    <div class="header-left-side">
        <button
            *ngIf="betControlPage == false"
            mat-icon-button
            (click)="opened = !opened"
        >
            <mat-icon mat-list-icon>menu</mat-icon>
        </button>
        <div class="imageHolder">
            <img
                src="{{ env }}/assets/exe.png"
                id="logo"
                class="logoHeader"
                alt="logo_exe"
            />
        </div>
    </div>
    <div
        class="header-right-side"
        *ngIf="betControlPage == !true"
    >
        <div
            class="logoCl"
            *ngIf="activeClient"
        >
            <img
                src="{{ env }}/assets/{{ activeClient }}.png"
                class="logoHeader"
                alt="logo"
            />
        </div>
        <div class="dropDownsHolder">
            <div class="dropDowns">
                <div
                    class="clDrowpdown"
                    *ngIf="loadedPerms && perms.superAdmin == 1"
                >
                    <button
                        mat-button
                        [matMenuTriggerFor]="menu"
                    >
                        {{ this.activeClient }}
                        <mat-icon>expand_more</mat-icon>
                    </button>

                    <mat-menu #menu="matMenu">
                        <ng-container *ngFor="let client of clients">
                            <button
                                id="btnClient"
                                *ngIf="client.active === 1"
                                mat-menu-item
                                (click)="clientChange(client)"
                            >
                                {{ client.name }}
                            </button>
                        </ng-container>
                    </mat-menu>
                </div>

                <div class="userDropDown">
                    <button
                        *ngIf="loadedPerms == true"
                        mat-button
                        [matMenuTriggerFor]="menu2"
                    >
                        {{ perms.username }}
                        <mat-icon>expand_more</mat-icon>
                    </button>
                    <mat-menu #menu2="matMenu">
                        <a
                            mat-menu-item
                            routerLink="/home/password_reset/"
                            routerLinkActive="active-link"
                            >Password</a
                        >
                        <button
                            mat-menu-item
                            (click)="logOut()"
                        >
                            Logout
                        </button>
                    </mat-menu>
                </div>
            </div>
        </div>
    </div>
</mat-toolbar>

<mat-sidenav-container
    *ngIf="betControlPage == !true && showTranslations == false"
>
    <mat-sidenav
        [opened]="opened"
        mode="side"
        [class.close]="!opened"
    >
        <app-side-navbar [opened]="opened"></app-side-navbar>
    </mat-sidenav>
    <mat-sidenav-content [class.close]="!opened">
        <router-outlet></router-outlet>
    </mat-sidenav-content>
</mat-sidenav-container>

<app-translations
    *ngIf="showTranslations"
    id="translations"
></app-translations>

<ng-container *ngIf="betControlPage == true">
    <div class="bet-control-container">
        <!-- Filter Panel -->
        <div class="filter-panel app-card-spacing">
            <div class="panel-header">
                <h3 class="panel-title">Search Filters</h3>
            </div>
            <form class="filter-form">
                <div class="filter-fields">
                    <!-- Date From -->
                    <div class="field-group">
                        <mat-form-field
                            appearance="fill"
                            class="unified-date-field"
                        >
                            <mat-label>Date From</mat-label>
                            <input
                                id="monthPickerFrom"
                                matInput
                                [matDatepicker]="pickerFrom"
                                [(ngModel)]="defaultDateFrom"
                                (dateChange)="setDateFrom($event)"
                                name="dateFrom"
                            />
                            <mat-datepicker-toggle
                                matSuffix
                                [for]="pickerFrom"
                            ></mat-datepicker-toggle>
                            <mat-datepicker
                                #pickerFrom
                                startView="multi-year"
                            ></mat-datepicker>
                        </mat-form-field>
                    </div>

                    <!-- Date To -->
                    <div class="field-group">
                        <mat-form-field
                            appearance="fill"
                            class="unified-date-field"
                        >
                            <mat-label>Date To</mat-label>
                            <input
                                id="monthPickerTo"
                                matInput
                                [matDatepicker]="pickerTo"
                                [(ngModel)]="defaultDateTo"
                                (dateChange)="setDateTo($event)"
                                name="dateTo"
                            />
                            <mat-datepicker-toggle
                                matSuffix
                                [for]="pickerTo"
                            ></mat-datepicker-toggle>
                            <mat-datepicker
                                #pickerTo
                                startView="multi-year"
                            ></mat-datepicker>
                        </mat-form-field>
                    </div>

                    <!-- Client Selector -->
                    <div class="field-group">
                        <mat-form-field
                            appearance="fill"
                            class="minimal-field"
                        >
                            <mat-label>Select Clients</mat-label>
                            <mat-select
                                multiple
                                [(ngModel)]="selectedClients"
                                name="selectedClients"
                            >
                                <mat-option
                                    *ngFor="let client of clients"
                                    [value]="client.clientUuid"
                                >
                                    {{ client.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div class="filter-actions">
                    <button
                        mat-flat-button
                        color="primary"
                        (click)="getClientInfo()"
                        type="button"
                        class="filter-btn"
                    >
                        <mat-icon>filter_list</mat-icon>
                        Filter
                    </button>
                    <button
                        mat-stroked-button
                        (click)="clearFilters()"
                        type="button"
                        class="clear-btn"
                    >
                        <mat-icon>clear</mat-icon>
                        Clear
                    </button>
                </div>
            </form>
        </div>

        <app-confirm-dialog
            [(visible)]="confirmationVisible"
            [message]="confirmationMessage"
            (confirmed)="onConfirmAction()"
        ></app-confirm-dialog>
        <!-- Statistics Table -->
        <div class="statistics-container">
            <mat-card class="table-card">
                <div class="table-header">
                    <h3 class="table-title">Client Statistics</h3>
                </div>

                <div class="mat-table-holder">
                    <!-- Loading State -->
                    <div
                        class="loading-statistics"
                        *ngIf="isLoading"
                    >
                        <mat-icon class="loading-icon"
                            >hourglass_empty</mat-icon
                        >
                        <span>Loading statistics...</span>
                    </div>

                    <!-- Statistics Table -->
                    <table
                        mat-table
                        [dataSource]="clientInfo"
                        class="mat-elevation-z2"
                        [class.hidden]="isLoading"
                    >
                        <!-- Client Name -->
                        <ng-container matColumnDef="clientName">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                (click)="sortBy('clientName')"
                            >
                                Client Name
                            </th>
                            <td
                                mat-cell
                                *matCellDef="let row"
                            >
                                {{ row.clientName }}
                            </td>
                            <td
                                mat-footer-cell
                                *matFooterCellDef
                                class="totals-row"
                            >
                                <strong>Totals</strong>
                            </td>
                        </ng-container>

                        <!-- Payin -->
                        <ng-container matColumnDef="payin">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                (click)="sortBy('payin')"
                            >
                                Payin
                            </th>
                            <td
                                mat-cell
                                *matCellDef="let row"
                                class="amount-cell"
                            >
                                {{ row.payin | number: '1.2-2' }}
                            </td>
                            <td
                                mat-footer-cell
                                *matFooterCellDef
                                class="totals-row amount-cell"
                            >
                                <strong>{{
                                    totalPayin | number: '1.2-2'
                                }}</strong>
                            </td>
                        </ng-container>

                        <!-- Payout -->
                        <ng-container matColumnDef="payout">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                (click)="sortBy('payout')"
                            >
                                Payout
                            </th>
                            <td
                                mat-cell
                                *matCellDef="let row"
                                class="amount-cell"
                            >
                                {{ row.payout | number: '1.2-2' }}
                            </td>
                            <td
                                mat-footer-cell
                                *matFooterCellDef
                                class="totals-row amount-cell"
                            >
                                <strong>{{
                                    totalPayout | number: '1.2-2'
                                }}</strong>
                            </td>
                        </ng-container>

                        <!-- Profit -->
                        <ng-container matColumnDef="profit">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                (click)="sortBy('profit')"
                            >
                                Profit
                            </th>
                            <td
                                mat-cell
                                *matCellDef="let row"
                                class="amount-cell"
                                [ngClass]="{
                                    positive: row.profit > 0,
                                    negative: row.profit < 0
                                }"
                            >
                                {{ row.profit | number: '1.2-2' }}
                            </td>
                            <td
                                mat-footer-cell
                                *matFooterCellDef
                                class="totals-row amount-cell"
                            >
                                <strong></strong>
                            </td>
                        </ng-container>

                        <!-- Revenue -->
                        <ng-container matColumnDef="revenue">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                (click)="sortBy('revenue')"
                            >
                                Revenue
                            </th>
                            <td
                                mat-cell
                                *matCellDef="let row"
                                class="amount-cell"
                                [ngClass]="{
                                    positive: row.revenue > 0,
                                    negative: row.revenue < 0
                                }"
                            >
                                {{ row.revenue | number: '1.2-2' }}
                            </td>
                            <td
                                mat-footer-cell
                                *matFooterCellDef
                                class="totals-row amount-cell"
                                [ngClass]="{
                                    positive: totalRevenue > 0,
                                    negative: totalRevenue < 0
                                }"
                            >
                                <strong>{{
                                    totalRevenue | number: '1.2-2'
                                }}</strong>
                            </td>
                        </ng-container>

                        <!-- Tickets Number -->
                        <ng-container matColumnDef="ticketsNumber">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                (click)="sortBy('ticketsNumber')"
                            >
                                Tickets Number
                            </th>
                            <td
                                mat-cell
                                *matCellDef="let row"
                                class="amount-cell"
                            >
                                {{ row.ticketsNumber }}
                            </td>
                            <td
                                mat-footer-cell
                                *matFooterCellDef
                                class="totals-row amount-cell"
                            >
                                <strong>{{ totalTickets }}</strong>
                            </td>
                        </ng-container>

                        <!-- Rows -->
                        <tr
                            mat-header-row
                            *matHeaderRowDef="
                                [
                                    'clientName',
                                    'payin',
                                    'payout',
                                    'profit',
                                    'revenue',
                                    'ticketsNumber'
                                ];
                                sticky: true
                            "
                        ></tr>
                        <tr
                            mat-row
                            *matRowDef="
                                let row;
                                columns: [
                                    'clientName',
                                    'payin',
                                    'payout',
                                    'profit',
                                    'revenue',
                                    'ticketsNumber'
                                ]
                            "
                        ></tr>
                        <tr
                            mat-footer-row
                            *matFooterRowDef="
                                [
                                    'clientName',
                                    'payin',
                                    'payout',
                                    'profit',
                                    'revenue',
                                    'ticketsNumber'
                                ];
                                sticky: true
                            "
                            class="totals-footer"
                        ></tr>
                    </table>
                </div>
            </mat-card>
        </div>
    </div>
</ng-container>

<mat-toolbar
    id="footer"
    color="primary"
    [ngClass]="{ footerAbs: showTranslations === true }"
>
    <!-- Left section -->
    <div class="footer-left">
        <!-- <mat-slide-toggle
            [formControl]="toggleControl"
            class="mr-8"
        ></mat-slide-toggle>
        <mat-icon>bedtime</mat-icon> -->
    </div>

    <!-- Center section -->
    <div class="footer-center">
        <app-time-zone *ngIf="showTranslations == false"></app-time-zone>
    </div>

    <!-- Right section - Admin buttons -->
    <div class="footer-right">
        <ng-container *ngIf="isSuperAdmin">
            <span
                mat-button
                routerLink="/bet-control"
                *ngIf="betControlPage == !true"
                class="btn_betControl"
                (click)="toggleSuperAdminPerm_BetControl()"
                >Bet Control</span
            >
            <span
                mat-button
                routerLink="/home"
                *ngIf="betControlPage == true"
                (click)="toggleSuperAdmin_home()"
                id="footerBtn"
                >Home</span
            >
            <span
                mat-button
                id="footerBtn"
                (click)="activateTranslations()"
                >Translations</span
            >
        </ng-container>
    </div>
</mat-toolbar>
